﻿/**
 * Class          : Icon
 * Author         : Pratheeshkumar N P
 * Created On     : 24-Apr-2025 
 * Other Fn calls :
 * Comments       :
 * ================================================================================================
 *   Last Modified By  ||    Date        ||    Purpose/Reason
 * ================================================================================================
 */
class Icon {
    constructor(svgContent) {
        this.svgContent = svgContent;
        this.tag = 'svg';
        this.attributes = {
            xmlns: 'http://www.w3.org/2000/svg',
            'xmlns:xlink': 'http://www.w3.org/1999/xlink',
            viewBox: '0 0 64 64',
            version: '1.1'
        };  
    } 
    createSVGElement() { 
        const svg = document.createElementNS('http://www.w3.org/2000/svg', this.tag); 
        for (const [key, value] of Object.entries(this.attributes)) {
            svg.setAttribute(key, value);
        }
        svg.classList.add('fe-icon');
        const content = this.parseSvgString(this.svgContent);
        content.forEach(el => {
            const element = document.createElementNS(this.attributes.xmlns, el.type);
            for (const [key, value] of Object.entries(el)) {
                if (key !== "type") {
                    element.setAttribute(key, value);
                }
            }
            svg.appendChild(element);
        });

        return svg;
    }
    parseSvgString(svgString) {
        const wrapper = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        wrapper.innerHTML = svgString;

        return Array.from(wrapper.children).map(el => {
            const obj = { type: el.tagName };
            Array.from(el.attributes).forEach(attr => {
                obj[attr.name] = attr.value;
            });
            return obj;
        });
    }

    render() {
        return this.createSVGElement();
    }
}


const table = '';
const textbox = '<path d="M50,14.8c2.2,0,4,1.8,4,4v26.5c0,2.2-1.8,4-4,4H14c-2.2,0-4-1.8-4-4v-26.5c0-2.2,1.8-4,4-4h36M50,10.8H14c-4.4,0-8,3.6-8,8v26.5c0,4.4,3.6,8,8,8h36c4.4,0,8-3.6,8-8v-26.5c0-4.4-3.6-8-8-8h0Z"/><line class="st0" x1="19.2" y1="20.3" x2="19.2" y2="29.8"/><line class="st0" x1="14" y1="19.9" x2="24.4" y2="19.9"/><line class="st0" x1="37.9" y1="45.2" x2="50.2" y2="33"/><line class="st0" x1="46.8" y1="46.1" x2="51.1" y2="41.8"/>';
const text = '<path d="M56.3,18.3c-.8,0-1.4-.6-1.4-1.4v-6.9c0-.6-.5-1.1-1.2-1.1h-6.9c-.8,0-1.4-.6-1.4-1.4s.6-1.4,1.4-1.4h6.9c2.2,0,4,1.8,4,4v6.9c0,.8-.6,1.4-1.4,1.4Z"/><path d="M7.1,18.3c-.8,0-1.4-.6-1.4-1.4v-6.9c0-2.2,1.8-4,4-4h6.9c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4h-6.9c-.6,0-1.1.5-1.1,1.1v6.9c0,.8-.6,1.4-1.4,1.4Z"/><path d="M16.5,58h-6.9c-2.2,0-4-1.8-4-4v-6.9c0-.8.6-1.4,1.4-1.4s1.4.6,1.4,1.4v6.9c0,.6.5,1.1,1.1,1.1h6.9c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4Z"/><path d="M53.7,58h-6.9c-.8,0-1.4-.6-1.4-1.4s.6-1.4,1.4-1.4h6.9c.6,0,1.2-.5,1.2-1.1v-6.9c0-.8.6-1.4,1.4-1.4s1.4.6,1.4,1.4v6.9c0,2.2-1.8,4-4,4Z"/><path d="M41.7,14h-24.1c-.6,0-1,.4-1,1v7c0,.6.4,1,1,1h3.8c.6,0,1-.4,1-1v-1.2c0-.6.4-1,1-1h4.8c.6,0,1,.4,1,1v22.4c0,.6-.4,1-1,1h-2c-.6,0-1,.4-1,1v3.8c0,.6.4,1,1,1h12c.6,0,1-.4,1-1v-3.8c0-.6-.4-1-1-1h-2.2c-.6,0-1-.4-1-1v-22.4c0-.6.4-1,1-1h4.8c.6,0,1,.4,1,1v1.2c0,.6.4,1,1,1h3.8c.6,0,1-.4,1-1v-7c0-.6-.4-1-1-1h-4.8Z"/>';
const checkbox = '<path d="M46,18v28h-28v-28h28M50,14H14v36h36V14h0Z"/><polyline class="st0" points="22.5 31.5 29.6 39 41.5 25.5"/>';
const combobox = '<path d="M53,14.8c.6,0,1,.4,1,1v32.5c0,.6-.4,1-1,1H11c-.6,0-1-.4-1-1V15.8c0-.6.4-1,1-1h42M53,10.8H11c-2.8,0-5,2.2-5,5v32.5c0,2.8,2.2,5,5,5h42c2.8,0,5-2.2,5-5V15.8c0-2.8-2.2-5-5-5h0Z"/><line class="st1" x1="41.2" y1="13.3" x2="41.2" y2="25.8"/><line class="st2" x1="14" y1="19.9" x2="24.4" y2="19.9"/><line class="st1" x1="13.9" y1="36.1" x2="41.2" y2="36.1"/><line class="st1" x1="13.9" y1="43" x2="29.9" y2="43"/><path d="M53,14.8c.6,0,1,.4,1,1v7.5c0,.6-.4,1-1,1H11c-.6,0-1-.4-1-1v-7.5c0-.6.4-1,1-1h42M53,10.8H11c-2.8,0-5,2.2-5,5v7.5c0,2.8,2.2,5,5,5h42c2.8,0,5-2.2,5-5v-7.5c0-2.8-2.2-5-5-5h0Z"/><polyline class="st0" points="45.6 21.3 48.6 18.3 51.7 21.3"/>';
const radio = '<path d="M32,18c7.7,0,14,6.3,14,14s-6.3,14-14,14-14-6.3-14-14,6.3-14,14-14M32,14c-9.9,0-18,8.1-18,18s8.1,18,18,18,18-8.1,18-18-8.1-18-18-18h0Z"/><path d="M32,24c-4.4,0-8,3.6-8,8s3.6,8,8,8,8-3.6,8-8-3.6-8-8-8h0Z"/>';
const signature = '<path d="M15.9,56.6c-2,0-3.5-.7-4.2-1.2-1.7-1.3-2.8-3.4-3-6-.3-3.2.7-10,9.6-19.3,3.5-3.6,6.6-5.9,9.4-7.2-.6-2.3-1.4-4.5-2.5-6.5-1.7-3.1-4.5-5-7.7-5.2-2.5-.2-4.7.7-6,2.3-1.4,1.7-2,3.4-1.7,5,.3,2,1.9,4,4.7,5.9.8.6,1.1,1.7.5,2.6-.6.8-1.7,1.1-2.6.5-3.7-2.5-5.8-5.3-6.3-8.4-.4-2.6.4-5.4,2.5-7.9,2.1-2.6,5.5-4,9.2-3.7,4.4.4,8.3,2.9,10.6,7.1,1.2,2.2,2.1,4.5,2.8,7.1,5.2-1.3,8.6.8,9.9,1.8,2.8,2.2,3.7,5.4,3.8,8.3,4-3.7,7.8-4.9,12.4-1.6.8.6,1,1.8.4,2.6-.6.8-1.8,1-2.6.4-2.5-1.9-4.9-2.6-11.3,5.5-.6.7-1.5.9-2.3.5-.8-.4-1.2-1.4-.9-2.2,0,0,2.4-7.3-1.7-10.5-.9-.7-3.2-2-7-1.1,1,7.1-.2,14.9-3.6,21.2-3,5.7-6.5,9-10.4,9.9-.7.2-1.3.2-1.9.2ZM28.4,26.7c-2.1,1.2-4.6,3.1-7.4,6-8.3,8.6-8.8,14.3-8.6,16.4.1,1.5.7,2.7,1.5,3.3,0,0,1.3.8,3.2.3,1.9-.5,4.8-2.2,7.9-8,2.9-5.4,4-11.9,3.3-18Z"/><path d="M54.4,52.4h-19c-1,0-1.8-.8-1.8-1.8s.8-1.8,1.8-1.8h19c1,0,1.8.8,1.8,1.8s-.8,1.8-1.8,1.8Z"/>';
const image = '<path d="M55,13.5H9c-1.7,0-3,1.3-3,3v31c0,1.7,1.3,3,3,3h46c1.7,0,3-1.3,3-3v-31c0-1.7-1.3-3-3-3ZM55,43l-6.1-7.2c-1.1-1.3-3-1.3-4.1,0l-8.5,10-14.9-17.6c-.8-1-2.3-1-3.2,0l-9.3,11v-22.8h46v26.5Z"/><circle cx="42" cy="25.5" r="4.5"/>';
const shape = '';

const alignLeft = '<rect x="13" y="10.7" width="27.2" height="16.6" rx="6" ry="6"/><rect x="6.1" y="6" width="3" height="52" rx="1.5" ry="1.5"/><rect x="13" y="37" width="40.9" height="16.8" rx="6" ry="6"/>';
const alignRight = '<rect x="23.2" y="10.7" width="27.2" height="16.6" rx="6" ry="6"/><rect x="54.4" y="6" width="3" height="52" rx="1.5" ry="1.5"/><rect x="9.5" y="37" width="40.9" height="16.8" rx="6" ry="6"/>';
const alignCenter = '<rect x="17.4" y="10.7" width="29.2" height="16.6" rx="6" ry="6"/><rect x="30.5" y="6" width="3" height="52" rx="1.5" ry="1.5"/><rect x="10.5" y="37" width="42.9" height="16.8" rx="6" ry="6"/>';
const alignTop = '<rect x="31.9" y="18.4" width="27.2" height="16.6" rx="6" ry="6" transform="translate(18.9 72.2) rotate(-90)"/><rect x="31" y="-18.4" width="3" height="52" rx="1.5" ry="1.5" transform="translate(24.9 40.1) rotate(-90)"/><rect x="-1.3" y="25.1" width="40.9" height="16.8" rx="6" ry="6" transform="translate(-14.3 52.7) rotate(-90)"/>';
const alignBottom = '<rect x="31.4" y="28.1" width="27.3" height="16.6" rx="6" ry="6" transform="translate(8.7 81.4) rotate(-90)"/><rect x="30.5" y="29.4" width="3" height="52" rx="1.5" ry="1.5" transform="translate(-23.4 87.4) rotate(-90)"/><rect x="-1.8" y="21.1" width="40.9" height="16.8" rx="6" ry="6" transform="translate(-10.9 48.2) rotate(-90)"/>';
const alignMiddle = '<rect x="30.4" y="23.7" width="29.2" height="16.6" rx="6" ry="6" transform="translate(77 -13) rotate(90)"/><rect x="30.5" y="6" width="3" height="52" rx="1.5" ry="1.5" transform="translate(64 0) rotate(90)"/><rect x="-2.8" y="23.6" width="42.9" height="16.8" rx="6" ry="6" transform="translate(50.7 13.4) rotate(90)"/>';

const width = '<polyline class="st0" points="43.5 22.6 52.8 31.9 43.3 41.4"/><line class="st0" x1="55.8" y1="15.5" x2="55.8" y2="48.5"/><line class="st0" x1="8.2" y1="15.5" x2="8.2" y2="48.5"/><line class="st0" x1="51.6" y1="32" x2="12.4" y2="32"/><polyline class="st0" points="20.4 41.4 11.1 32.1 20.6 22.6"/>';
const height = '<polyline class="st0" points="22.6 20.5 31.9 11.2 41.4 20.7"/><line class="st0" x1="15.5" y1="8.2" x2="48.5" y2="8.2"/><line class="st0" x1="15.5" y1="55.8" x2="48.5" y2="55.8"/><line class="st0" x1="32" y1="12.4" x2="32" y2="51.6"/><polyline class="st0" points="41.4 43.6 32.1 52.9 22.6 43.4"/>';





 

const svgIcon = {
    textbox: new Icon(textbox),
    text: new Icon(text),
    combobox: new Icon(combobox),
    checkbox: new Icon(checkbox),
    radio: new Icon(radio),
    button: new Icon(radio),
    signature: new Icon(signature),
    table: new Icon(table), 
    image: new Icon(image), 
    shape: new Icon(shape), 
    alignLeft: new Icon(alignLeft), 
    alignRight: new Icon(alignRight), 
    alignCenter: new Icon(alignCenter),
    alignTop: new Icon(alignTop), 
    alignBottom: new Icon(alignBottom), 
    alignMiddle: new Icon(alignMiddle), 

    width: new Icon(width), 
    height: new Icon(height), 
};

export default svgIcon;
